module.exports = __webpack_public_path__ + "img/ico-mapage.81aadb4d.svg";